module.exports = "/reports/sales-cb21e3.html";